<template>
  <div>
    <el-container class="p-3">
      <el-form inline>
        <el-form-item>
          <el-button
            v-if="$route.meta.action.c"
            type="primary"
            @click="
              updateDialog = true;
              form.name = '';
              form.id = null;
              form.description = '';
              form.uniformNum = '00000000';
              edit = false;
            "
          >
            新增
          </el-button>
        </el-form-item>
      </el-form>
      <div class="" />
    </el-container>
    <el-table :data="companies" style="width: 100%" stripe>
      <el-table-column prop="name" label="名稱" width="300" />
      <el-table-column prop="description" label="說明" />
      <el-table-column prop="mvmCount" label="機台數量">
        <template slot-scope="scope"> {{ scope.row.mvmCount }} </template>
      </el-table-column>
      <el-table-column v-if="$route.meta.action.u" label="動作">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="
              updateDialog = true;
              form.name = scope.row.name;
              form.id = scope.row.id;
              form.uniformNum = scope.row.uniformNum;
              form.description = scope.row.description;
              edit = true;
            "
          >編輯</el-button>
        </template>
      </el-table-column>
      <el-table-column v-if="$route.meta.action.u" label="聯絡人">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="
              profileDialog = true;
              selectCompanyID = scope.row.id;
            "
          >聯絡人</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="profileDialog">
      <profile v-if="profileDialog" :company_id="selectCompanyID" />
    </el-dialog>

    <el-dialog
      title="經銷商"
      :visible.sync="updateDialog"
      @closed="collapse = 2"
    >
      <el-form ref="form" :rules="rules" :model="form">
        <el-form-item label="經銷商名稱" prop="name">
          <el-input v-model="form.name" autocomplete="off" />
        </el-form-item>
        <el-form-item label="經銷商說明">
          <el-input
            v-model="form.description"
            type="textarea"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item label="統一編號">
          <el-input v-model="form.uniformNum" autocomplete="off" />
        </el-form-item>
      </el-form>
      <el-collapse v-if="edit" v-model="collapse">
        <el-collapse-item name="1">
          <template slot="title">
            <div class="text-danger">
              危險動作 <i class="header-icon el-icon-warning" />
            </div>
          </template>
          <el-popconfirm title="確定刪除?" @confirm="deleteItem(form.id)">
            <el-button slot="reference" type="danger">刪除經銷商</el-button>
          </el-popconfirm>
        </el-collapse-item>
      </el-collapse>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateDialog = false">取消</el-button>
        <el-button type="primary" @click="update">確定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getProducts, deleteProducts } from '@/api/product'
import { getCompanies, updateCompany, deleteCompany } from '@/api/companies'
import { mapGetters } from 'vuex'
import ExportExcel from '@/components/ExportExcel/index.vue'
import profile from '@/components/profile/index.vue'
const methods = {
  async init() {
    const companies = await getCompanies()
    this.companies = await this.countMvm(companies)
  },

  async countMvm(companies) {
    companies.forEach((item) => {
      let mvmCount = 0
      item.clients.forEach((c) => {
        mvmCount += c.mvm.length
      })
      item.mvmCount = mvmCount
    })
    return companies
  },
  async update() {
    const valid = await this.$refs['form'].validate().catch((err) => {
      return err
    })
    if (!valid) return
    try {
      const data = await updateCompany(this.form)
      this.$message({
        message: '成功',
        type: 'success'
      })
      this.updateDialog = false
      this.$refs['form'].resetFields()
      this.init()
    } catch (error) {}
  },
  async deleteItem(id) {
    try {
      const data = await deleteCompany({ id })
      this.$message({
        message: '成功',
        type: 'success'
      })
      this.updateDialog = false
      this.init()
    } catch (error) {}
  }
}
export default {
  data() {
    return {
      updateDialog: false,
      profileDialog: false,
      collapse: 1,
      companies: [],
      edit: false,
      selectCompanyID: null,
      form: {
        id: null,
        name: '',
        description: '',
        uniformNum: '00000000'
      },
      columns: [
        { label: '名稱', field: 'name' },
        { label: '說明', field: 'description' }
      ],
      rules: {
        name: [{ required: true, message: '必填', trigger: 'blur' }]
      }
    }
  },
  async created() {
    await this.init()
  },
  methods,
  computed: {
    ...mapGetters(['permission_routes'])
  },
  components: {
    ExportExcel,
    profile
  }
}
</script>
